/**
 * @generated SignedSource<<7ec4d60d2915cd19293ecf5809ecdc2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestoreProgramInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type RestoreProgramMutation$variables = {
  input: RestoreProgramInput;
};
export type RestoreProgramMutation$data = {
  readonly restoreProgram: {
    readonly programId: string;
  } | null | undefined;
};
export type RestoreProgramMutation = {
  response: RestoreProgramMutation$data;
  variables: RestoreProgramMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RestoreProgramPayload",
    "kind": "LinkedField",
    "name": "restoreProgram",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "programId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RestoreProgramMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestoreProgramMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7c350ab84d51220cffd2fae757f9f25f",
    "id": null,
    "metadata": {},
    "name": "RestoreProgramMutation",
    "operationKind": "mutation",
    "text": "mutation RestoreProgramMutation(\n  $input: RestoreProgramInput!\n) {\n  restoreProgram(input: $input) {\n    programId\n  }\n}\n"
  }
};
})();

(node as any).hash = "492ef685c296d4c70e62e6e409e1be33";

export default node;
